import React from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { LoadingAnimation } from '@sg/garnish';

import { useIsLoggedIn } from '@order/AuthMachine';
import { Bag } from '@order/features/ordering';
import { useCloseBag } from '@order/hooks';
import { useFeatureFlag } from '@order/LaunchDarkly';

import { BagAnimatedDialog, BagContent } from './components';
import { useBagGestures, useOrderState } from './hooks';

export const BagScreen = () => {
  const isExpressPaymentsEnabled = useFeatureFlag(
    'permanent-order-stripe-express-checkout-enabled',
  );

  const orderState = useOrderState({ isExpressPaymentsEnabled });

  const { isFetchingInitialData, isShowingModal, startOrdering } = orderState;

  // ──────────────────────────────────────────────────────────────────────────

  const closeBag = useCloseBag();

  // Enable/disable gestures when modal is shown.
  useBagGestures(isShowingModal);

  // Fetch ordering data on bag focus.
  useFocusEffect(startOrdering);

  // ──────────────────────────────────────────────────────────────────────────

  return (
    <Bag.DynamicModal onClose={closeBag}>
      {isFetchingInitialData ? (
        <LoadingAnimation />
      ) : (
        <BagScreenReady orderState={orderState} />
      )}
    </Bag.DynamicModal>
  );
};

const BagScreenReady = (props: BagScreenReadyProps) => {
  const { orderState } = props;
  const { isBagEmpty } = orderState;

  const isLoggedIn = useIsLoggedIn();

  if (!isLoggedIn || isBagEmpty) {
    return <BagContent orderState={orderState} />;
  }

  return (
    <>
      <BagContent orderState={orderState} />

      <BagAnimatedDialog orderState={orderState} />
    </>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type BagScreenReadyProps = {
  orderState: ReturnType<typeof useOrderState>;
};
